const state = {
  show: false,
  text: '',
  color: '',
};

const actions = {
  setShow({ state }, { show }) {
    state.show = show;
  },
  setText({ state }, { text }) {
    state.text = text;
  },
  setColor({ state }, { color }) {
    state.color = color;
  },
};

const getters = {
  getShow(s) {
    return s.show;
  },
  getText(s) {
    return s.text;
  },
  getColor(s) {
    return s.color;
  },
};

export default {
  state,
  actions,
  getters,
  namespaced: true,
};
